const nl = {
  app: {
    title: 'AllPhi Mobiliteit',
    subtitle: 'Werknemersportaal',
    logoAlt: 'AllPhi-logo',
    signOut: 'Afmelden',
    darkMode: 'Donkere modus',
    lightMode: 'Lichte modus',
    language: 'Taal',
    dutch: 'Nederlands',
    english: 'Engels',
    accountMenu: 'Accountmenu',
  },
  nav: {
    budget: 'Mijn budget',
    claims: 'Mijn onkostennota\u2019s (Pijler 2)',
  },
  auth: {
    title: 'AllPhi Mobiliteitsportaal',
    subtitle: 'Meld je aan met je Microsoft-werkaccount om verder te gaan.',
    signIn: 'Aanmelden',
  },
  common: {
    cancel: 'Annuleren',
    close: 'Sluiten',
    save: 'Opslaan',
    invalidDateFormat: 'Gebruik een geldige datum in het formaat dd/mm/jjjj.',
    datePlaceholder: 'dd/mm/jjjj',
  },
  mobility: {
    fields: {
      year: 'Jaar',
      annualBudget: 'Jaarbudget',
      availableBalance: 'Beschikbaar saldo',
      status: 'Status',
      actions: 'Acties',
      date: 'Datum',
      entryType: 'Type boeking',
      amount: 'Bedrag',
      description: 'Omschrijving',
      attachments: 'Bijlagen',
    },
    accounts: {
      stateClosed: 'Afgesloten',
    },
    ledger: {
      types: {
        BudgetGrant: 'Jaarbudget',
        CarCost: 'Wagenkost',
        ExpenseReimbursement: 'Onkost',
        CashPayout: 'Uitbetaling pijler 3',
        Adjustment: 'Correctie',
        MonthlyRelease: 'Maandelijkse vrijgave',
        YearlyRelease: 'Jaarlijkse vrijgave',
      },
      descriptions: {
        MonthlyRelease: 'Mobiliteitsbudget vrijgegeven op het einde van de maand',
        YearlyRelease: 'Volledig resterend jaarbudget in één keer vrijgegeven',
        ExpenseReimbursement: 'Terugbetaling onkostennota #{{id}}',
        ExpenseReimbursementDetailed: '{{type}}',
        ExpenseRefund: 'Terugboeking geannuleerde onkostennota #{{id}}',
        ExpenseRefundDetailed: 'Terugboeking: {{type}}',
      },
    },
    claimStatus: {
      Draft: 'Concept',
      Submitted: 'Ingediend',
      UnderReview: 'In beoordeling',
      Approved: 'Goedgekeurd',
      Rejected: 'Afgewezen',
      PayrollReady: 'Klaar voor loon',
      Processed: 'Verwerkt',
      Cancelled: 'Geannuleerd',
    },
    self: {
      notLinkedTitle: 'Geen mobiliteitsprofiel gevonden',
      notLinked: 'Je account is nog niet gekoppeld aan een werknemersprofiel. Neem contact op met HR of Finance.',
      budgetInactiveTitle: 'Mobiliteitsbudget nog niet actief',
      budgetInactiveMessage: 'Je huidige en toegewezen categorie zijn al zichtbaar. Leasegegevens, TCO-bedragen, de mobiliteitsbudgetberekening en onkostennota\u2019s worden pas getoond zodra het mobiliteitsbudget actief is.',
      budgetTitle: 'Mijn mobiliteitsbudget',
      budgetSubtitle: 'Bekijk je jaarbudget, categorie en verrichtingen.',
      balanceCardTitle: 'Mijn beschikbaar budget',
      balanceCardSubtitle: 'Wat je vandaag werkelijk kunt gebruiken',
      availableNow: 'Nu beschikbaar voor onkosten',
      regularReleased: 'Regulier vrijgegeven voor Pijler 2',
      budgetComposition: 'Opbouw jaarbudget voor Pijler 2 en 3',
      annualBudgetPillars: 'Jaarbudget voor Pijler 2 en 3',
      annualBudgetExplanation: 'Dit bedrag is het verschil tussen je totale mobiliteitsbudget en Pijler 1, dag-pro-rata berekend voor {{startDate}} t.e.m. {{endDate}} binnen boekjaar {{year}}.',
      annualBudgetExplanationNoLease: 'Dit is het beschikbare jaarbudget voor Pijler 2 en 3 in boekjaar {{year}}.',
      yearlyReleaseLeaverDisclaimer: 'Als je het bedrijf verlaat, wordt dit budget herberekend van 01/01/{{year}} tot en met je laatste werkdag, pro rata per kalenderdag.',
      usageAndProjection: 'Gebruik via Pijler 2 en projectie Pijler 3',
      perMonth: 'per maand',
      expenses: 'Gebruikt via onkostennota\u2019s (Pijler 2)',
      projectedPillarThree: 'Geprojecteerde netto-uitbetaling (Pijler 3)',
      pillarThreeDescription: 'Pijler 3 betaalt het resterende budget op het einde van het boekjaar in cash uit. Op het brutobedrag wordt een bijzondere werknemersbijdrage ingehouden.',
      pillarThreeExplanation: 'Projectie bij ongewijzigde uitgaven: {{gross}} bruto, verminderd met {{contribution}} bijzondere werknemersbijdrage ({{rate}}%).',
      monthEndReleaseInfo: 'Het budget van elke maand wordt pas op de laatste kalenderdag van die maand beschikbaar.',
      releaseModeYearly: 'Jaarlijkse vrijgave',
      switchToYearlyRelease: 'Overschakelen naar jaarlijkse vrijgave',
      switchToYearlyReleaseTitle: 'Overschakelen naar jaarlijkse vrijgave',
      switchToYearlyReleaseWarning: 'Zodra je overschakelt, komt je volledige jaarbudget voor Pijler 2/3 onmiddellijk beschikbaar in plaats van maand na maand vrijgegeven te worden. Je verliest de maandelijkse indicatie van ‘wat je tot nu toe hebt opgebouwd’ voor de rest van dit boekjaar. Deze keuze ligt vast voor {{year}} en kan niet worden teruggedraaid. Verlaat je het bedrijf, dan wordt je budget nog steeds pro rata herberekend tot je uitdiensttredingsdatum.',
      switchToYearlyReleaseConfirmLabel: 'Ik begrijp dit en wil overschakelen naar jaarlijkse vrijgave.',
      switchToYearlyReleaseConfirm: 'Overschakelen naar jaarlijkse vrijgave',
      switchToYearlyReleaseSuccess: 'Je mobiliteitsbudget wordt nu jaarlijks vrijgegeven voor {{year}}.',
      profileCardTitle: 'Mijn categorie en wagen',
      profileCardSubtitle: 'Je huidige situatie en volgende overstap',
      nextCategoryInfo: 'Je schakelt over naar categorie {{category}} op {{date}}.',
      overheadCategoryInfo: 'Je categorie ligt vast volgens het bedrijfsbeleid en wordt niet berekend op basis van ervaringsjaren of punten.',
      categoryRuleUpgrade: 'Je huidige lease loopt van {{startDate}} tot {{endDate}}. Je formulecategorie is nu {{calculatedCategory}}. Omdat die hoger is dan je toegewezen categorie {{assignedCategory}}, kun je bij de keuze van je volgende wagen vanaf {{switchDate}} overstappen naar categorie {{nextCategory}}. Tijdens de lopende lease verandert je toegewezen categorie niet automatisch.',
      categoryRuleNoUpgrade: 'Je huidige lease loopt van {{startDate}} tot {{endDate}}. Je formulecategorie is nu {{calculatedCategory}} en je toegewezen categorie is {{assignedCategory}}. Tijdens de lopende lease verandert die toegewezen categorie niet automatisch. Bij de keuze van je volgende wagen wordt opnieuw bekeken of je volgens de formule naar een hogere categorie kunt overstappen.',
      highestCategory: 'Je bevindt je al in de hoogste categorie.',
      vehicleDetailsTitle: 'Opbouw mobiliteitsbudget',
      leasePeriod: 'Leasingperiode',
      entitledMonthlyTco: 'Totaal mobiliteitsbudget',
      entitledMonthlyTcoHelper: 'Het volledige maandbedrag waarop je recht hebt.',
      vehicleMonthlyTco: 'Pijler 1 · Bedrijfswagen',
      vehicleMonthlyTcoHelper: 'Het maandbedrag dat voor je huidige wagen wordt gebruikt.',
      monthlyMobilityDifference: 'Beschikbaar voor Pijler 2 of 3',
      monthlyMobilityDifferenceHelper: 'Voor onkosten via Pijler 2 of de eindejaarsuitbetaling via Pijler 3.',
      noAccount: 'Je hebt nog geen mobiliteitsbudgetrekening voor {{year}}.',
      category: 'Mobiliteitscategorie',
      currentCategory: 'Huidige categorie',
      assignedCategory: 'Toegewezen categorie',
      eligibleCategory: 'Huidige categorie',
      vehicleCategory: 'Categorie mobiliteitsbudget',
      noCategory: 'Niet ingesteld',
      noVehicle: 'Geen actieve wagen gekoppeld',
      employmentStartDate: 'Datum in dienst',
      yearsBeforeCompany: 'Ervaring vóór AllPhi',
      allowedChoices: 'Toegestane keuzes',
      relevantYears: 'Relevante ervaring (jaren)',
      points: 'Punten',
      ledgerTitle: 'Verrichtingen',
      ledgerSubtitle: 'Een helder overzicht van maandelijkse vrijgaven, vervroegde vrijgaven en uitgaven.',
      noTransactions: 'Nog geen verrichtingen voor dit jaar',
      rowsPerPage: 'Rijen per pagina:',
      claimsTitle: 'Mijn onkostennota\u2019s (Pijler 2)',
      claimsSubtitle: 'Dien onkosten in voor terugbetaling uit je mobiliteitsbudget (Pijler 2).',
      newClaim: 'Nieuwe onkostennota',
      createTitle: 'Onkostennota indienen',
      createSubtitle: 'Kies een toegelaten uitgave, vul de gegevens in en voeg meteen je bewijsstuk toe.',
      pillarTwoIntro: 'Uitgaven in pijler 2 zijn vrijgesteld van belastingen en socialezekerheidsbijdragen. De kost van een eventuele bedrijfswagen wordt eerst van je mobiliteitsbudget afgetrokken.',
      stepExpenseType: 'Stap 2',
      chooseExpenseType: 'Waarvoor heb je kosten gemaakt?',
      chooseSpecificExpense: 'Kies de passende onkostensoort',
      expenseTypesError: 'De onkostensoorten konden niet worden geladen. Probeer het later opnieuw.',
      noExpenseTypes: 'Er zijn momenteel geen onkostensoorten beschikbaar. Neem contact op met Finance.',
      eligibilityTitle: 'Wat komt in aanmerking binnen pijler 2?',
      eligibilitySubtitle: 'Bekijk de voorwaarden en voorbeelden voordat je indient.',
      eligibilityWarning: 'Vliegtickets en verhuiskosten komen niet in aanmerking. Gemotoriseerde voertuigen binnen zachte of gedeelde mobiliteit moeten voor aankopen, huur of leasing vanaf 1 januari 2026 emissievrij zijn.',
      stepExpenseDetails: 'Stap 1',
      expenseDetailsTitle: 'Gegevens van de uitgave',
      descriptionPlaceholder: 'Beschrijf kort wat je hebt aangekocht of welke dienst je hebt gebruikt.',
      stepProof: 'Stap 3',
      proofTitle: 'Bewijs van de kost',
      proofRequired: 'Een factuur, ticket of betalingsbewijs is verplicht voor deze onkostensoort.',
      proofOptional: 'Voeg bij voorkeur een factuur, ticket of betalingsbewijs toe.',
      proofChip: 'Bewijs vereist',
      proofDropTitle: 'Sleep je bewijsstuk hierheen',
      proofFormats: 'PDF, JPG of PNG · maximaal 10 MB',
      chooseProof: 'Bestand kiezen',
      replaceProof: 'Bestand vervangen',
      proofUploaded: 'Bewijsstuk geüpload',
      proofInvalidType: 'Gebruik een PDF-, JPG- of PNG-bestand.',
      proofTooLarge: 'Het bestand mag maximaal 10 MB groot zijn.',
      draftCreatedRetry: 'Je concept is bewaard. Het uploaden of indienen lukte nog niet; je kunt het hieronder opnieuw proberen.',
      createAndSubmit: 'Onkostennota indienen',
      retrySubmit: 'Opnieuw proberen',
      createdAndSubmitted: 'Je onkostennota en bewijsstuk zijn ingediend.',
      expenseType: 'Onkostensoort',
      amount: 'Bedrag',
      date: 'Betalingsdatum',
      expenseCoversPeriod: 'Deze kost heeft betrekking op een periode',
      periodEndDate: 'Einddatum periode',
      expensePeriod: 'Periode van de kost',
      description: 'Omschrijving',
      descriptionOptional: 'Notitie (optioneel)',
      noDescription: 'Geen omschrijving opgegeven',
      addAttachment: 'Bijlage toevoegen',
      submit: 'Indienen',
      cancel: 'Annuleren',
      created: 'Onkostennota aangemaakt.',
      submitted: 'Onkostennota ingediend.',
      cancelled: 'Onkostennota geannuleerd.',
      attachmentAdded: 'Bijlage toegevoegd.',
      attachmentRequired: 'Voor deze onkostensoort is een bijlage vereist.',
      useToday: 'Vandaag gebruiken',
      claimDetailsTitle: 'Details onkostennota',
      rejectionReason: 'Reden van afwijzing',
      noRejectionReason: 'De beoordelaar heeft geen reden opgegeven.',
      attachmentsTitle: 'Bewijsstukken',
      noAttachments: 'Er zijn geen bewijsstukken toegevoegd.',
      reviseAndResubmit: 'Aanpassen en opnieuw indienen',
      reviseTitle: 'Afgewezen onkostennota aanpassen',
      reviseExplanation: 'Pas de informatie aan en voeg indien nodig een nieuw bewijsstuk toe. Na indienen wordt de nota opnieuw door Finance beoordeeld.',
      addReplacementProof: 'Nieuw bewijsstuk toevoegen',
      resubmit: 'Opnieuw indienen',
      resubmitted: 'Je onkostennota is aangepast en opnieuw ingediend.',
      homeAddress: 'Thuisadres',
      workAddress: 'Werkadres',
      street: 'Straat',
      houseNumber: 'Nr.',
      postalCode: 'Postcode',
      city: 'Gemeente',
      amountToBeCalculated: 'Te berekenen',
      distanceCalculationInfo: 'Voor woon-werkverkeer vul je geen bedrag in. Geef je thuis- en werkadres op: F&A bepaalt de afstand en berekent het bedrag (kilometers × prijs per kilometer). Voor de berekening wordt de kortste afstand tussen beide adressen gebruikt.',
      distanceCalculation: 'Berekening',
      distanceBreakdown: '{{km}} km × {{rate}} per km',
    },
    claimCategories: {
      softMobility: { short: 'Fiets, step, bromfiets, elektrische motor en beschermende uitrusting.' },
      publicTransport: { short: 'Abonnementen en tickets voor trein, tram, bus, metro of waterbus.' },
      collectiveTransport: { short: 'Georganiseerd vervoer, zoals een kantoorbus.' },
      sharedMobility: { short: 'Deelvervoer, taxi, carpooling of tijdelijke voertuighuur.' },
      mobilityServices: { short: 'Een combinatie van duurzame vervoersdiensten.' },
      housing: { short: 'Huur of hypotheek voor een woning op maximaal 10 km van het werk.' },
      bicycleAllowance: { short: 'Vergoeding voor werkelijk te fiets afgelegd woon-werkverkeer.' },
      parking: { short: 'Parkeren in combinatie met een openbaarvervoerabonnement.' },
      pedestrian: { short: 'Vergoeding voor werkelijk te voet afgelegd woon-werkverkeer.' },
      management: { short: 'Kosten voor het beheer van het mobiliteitsbudget.' },
      other: { short: 'Andere toegelaten duurzame mobiliteitskost.' },
    },
    expenseGroups: {
      transport: {
        title: 'Duurzaam vervoer',
        subtitle: 'Vervoermiddelen en diensten',
      },
      housing: {
        title: 'Huisvesting',
        subtitle: 'Wonen dicht bij het werk',
      },
      allowances: {
        title: 'Woon-werk',
        subtitle: 'Fiets- en voetgangersvergoeding',
      },
    },
    eligibility: {
      softMobility: {
        title: 'Zachte mobiliteit',
        description: 'Aankoop, huur, leasing, financiering, onderhoud en stalling van fietsen, steps, bromfietsen, elektrische motorfietsen en bepaalde elektrische drie- of vierwielers. Ook veiligheids- en zichtbaarheidsuitrusting, zoals een helm of fluohesje, kan in aanmerking komen.',
      },
      publicTransport: {
        title: 'Openbaar vervoer',
        description: 'Abonnementen voor de werknemer en inwonende gezinsleden en losse tickets voor personen naar keuze. Trein, tram, bus, metro, waterbus, intercitybus en hogesnelheidstrein zijn toegestaan; vliegtickets niet.',
      },
      collectiveAndShared: {
        title: 'Gemeenschappelijk vervoer, deeloplossingen en mobiliteitsdiensten',
        description: 'Onder meer kantoorbus, carpooling, deelauto, deelscooter, deelfiets, deelstep, taxi en platformdiensten. Een voertuig zonder chauffeur mag maximaal 30 kalenderdagen per jaar worden gehuurd.',
      },
      housing: {
        title: 'Huisvestingskosten',
        description: 'Huur, hypotheekinteresten en kapitaalsaflossingen komen in aanmerking wanneer de woning binnen 10 km in vogelvlucht van de normale werkplaats ligt. Verhuiskosten zijn uitgesloten.',
      },
      allowances: {
        title: 'Fietspremie, parkeren en voetgangerspremie',
        description: 'Deze vergoedingen vereisen een aantoonbare band met het woon-werkverkeer. Parkeerkosten zijn alleen toegestaan wanneer ze samenhangen met het gebruik van openbaar vervoer.',
      },
      management: {
        title: 'Beheerskosten',
        description: 'Kosten voor het beheer van het mobiliteitsbudget kunnen sinds 1 januari 2024 via pijler 2 worden aangerekend.',
      },
    },
  },
};

export default nl;
